export var UserAvatarSizes;
(function (UserAvatarSizes) {
    UserAvatarSizes["small"] = "small";
    UserAvatarSizes["medium"] = "medium";
    UserAvatarSizes["large"] = "large";
    UserAvatarSizes["huge"] = "huge";
})(UserAvatarSizes || (UserAvatarSizes = {}));
//# sourceMappingURL=constants.js.map